import { render } from "./KitchenPrintQueue.vue?vue&type=template&id=732ae0d7&scoped=true"
import script from "./KitchenPrintQueue.vue?vue&type=script&lang=js"
export * from "./KitchenPrintQueue.vue?vue&type=script&lang=js"

import "./KitchenPrintQueue.vue?vue&type=style&index=0&id=732ae0d7&scoped=true&lang=css"
import "./KitchenPrintQueue.vue?vue&type=style&index=1&id=732ae0d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732ae0d7"]])

export default __exports__